import React, { useEffect, useState } from "react";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { MainText } from "app/components/common";
import { ITaggedPeople } from "app/utils/Types/type";
import { useDispatch } from "react-redux";
import Autolink from "react-native-autolink";
import theme from "app/Theme/Theme";

interface IuseTagUser {
  isNotFromInput: boolean;
}

// !!! Attention, si isNotFromInput true, et que l'on est dans un input, un dossier apparait à la place du nom
// TODO transformer tout les texts ici en utilisant Autolink
// ? Avantage => un matcher optimisé, moins de code, réalisé par un vrai dev ^^, moins de code
const useTagUser = ({ isNotFromInput = true }: IuseTagUser) => {
  const [taggedPeople, setTaggedPeople] = useState<ITaggedPeople[]>([]);
  const [textFormatWithColor, setTextFormatWithColor] = useState(<></>);
  const [textFormatInString, setTextFormatInString] = useState<string>("");

  const dispatch = useDispatch();

  const splitTaggedPeople = (text: string) => {
    const splitedComment = text.split("@");
    const newTaggedTable: ITaggedPeople[] = [];

    const commentInfos = splitedComment.map(subString => {
      if (subString[0] === "[") {
        const taggedId = subString.slice(
          subString.indexOf("[") + 1,
          subString.lastIndexOf("]"),
        );
        const stringObject = JSON.parse(taggedId);

        if (typeof stringObject === "object") {
          newTaggedTable.push(stringObject);
          return (
            stringObject.name + subString.slice(subString.lastIndexOf("]") + 1)
          );
        }
      }
      return subString;
    });
    return [commentInfos, newTaggedTable];
  };

  const formatTaggedUserBackToFront = (text: string) => {
    const splitPeople = splitTaggedPeople(text).filter(element => element);
    const commentFormat = splitPeople[0].filter(element => element).join(" ");
    const taggedInfos = splitPeople[1];

    setTaggedPeople(taggedInfos);
    setTextFormatInString(commentFormat);
    formatTextColor(commentFormat, taggedInfos);
  };

  const removeTaggedPeople = index => {
    taggedPeople.splice(index, 1);
  };

  const seeUser = (userId: string) => {
    dispatch(requestExternalUser({ userId: userId }));
  };

  const onClickUser = userId => () => {
    if (isNotFromInput) {
      seeUser(userId);
    }
  };

  const formatTextColor = (
    textToFormat: string,
    taggedTable?: ITaggedPeople[],
  ) => {
    let formatString = <></>;
    let fullString = "";
    let lastPosition = 0;

    if (taggedTable === undefined) {
      taggedTable = taggedPeople;
    }

    taggedTable.map((tagged, index) => {
      if (tagged.startposition !== 0 && formatString === <></>) {
        formatString = (
          <MainText variant="l4-medium">
            <Autolink
              url
              text={textToFormat.slice(0, tagged.startposition - 1)}
              linkStyle={{ color: theme.colors["brand.500"] }}
            />
          </MainText>
        );
        fullString = textToFormat.slice(0, tagged.startposition - 1);
      }
      const subString = textToFormat.slice(
        tagged.startposition,
        tagged.endPosition,
      );
      if (subString === tagged.name) {
        formatString = (
          <>
            {formatString}
            {lastPosition !== 0 && (
              <MainText variant="l4-medium">
                <Autolink
                  url
                  text={textToFormat.slice(
                    lastPosition,
                    tagged.startposition - 1,
                  )}
                  linkStyle={{ color: theme.colors["brand.500"] }}
                />
              </MainText>
            )}
            <MainText
              variant="l4-medium"
              color="brand.500"
              onPress={onClickUser(tagged.userId)}
              suppressHighlighting
            >
              {subString}
            </MainText>
          </>
        );
        if (lastPosition !== 0) {
          fullString += textToFormat.slice(
            lastPosition,
            tagged.startposition - 1,
          );
        }
        fullString += subString;
        lastPosition = tagged.endPosition;
      } else if (subString !== tagged.name) {
        removeTaggedPeople(index);
        // formatString = (
        //   <>
        //     {formatString}
        //     <MainText variant="l2-regular">
        //       @{textToFormat.slice(lastPosition, tagged.endPosition - 1)}
        //     </MainText>
        //   </>
        // ); // TODO when we will want to tag avec list de personne
        lastPosition = tagged.endPosition - 1;
      }
    });
    if (lastPosition <= textToFormat.length) {
      formatString = (
        <>
          {formatString}
          <MainText variant="l4-medium">
            <Autolink
              url
              text={textToFormat.slice(lastPosition, textToFormat.length)}
              linkStyle={{ color: theme.colors["brand.500"] }}
            />
          </MainText>
        </>
      );
      fullString += textToFormat.slice(lastPosition, textToFormat.length);
    }

    setTextFormatInString(fullString);
    setTextFormatWithColor(formatString);
  };

  const formatTextFromToBack = () => {
    let textToSend = "";
    let lastPosition = 0;

    taggedPeople.map((tagged, index) => {
      const textTagged = JSON.stringify(tagged);
      textToSend +=
        textFormatInString.slice(lastPosition, tagged.startposition) +
        "@[" +
        textTagged +
        "]";
      lastPosition = tagged.endPosition;
    });
    if (lastPosition <= textFormatInString.length) {
      textToSend += textFormatInString.slice(
        lastPosition,
        textFormatInString.length + 1,
      );
    }
    return textToSend;
  };

  const resetAllTag = () => {
    setTaggedPeople([]);
    setTextFormatWithColor(<></>);
    setTextFormatInString("");
  };

  const addTagUser = (
    newTag: ITaggedPeople,
    params: { isFirstWord: boolean } = { isFirstWord: false },
  ) => {
    const { isFirstWord } = params;
    const newTaggedTable = isFirstWord ? [newTag] : [...taggedPeople, newTag];
    const newFormatInString = isFirstWord
      ? newTag.name + " "
      : textFormatInString + newTag.name + " ";
    setTaggedPeople(newTaggedTable);
    formatTextColor(newFormatInString, newTaggedTable);
  };

  return [
    textFormatWithColor,
    textFormatInString,
    addTagUser,
    formatTextColor,
    formatTaggedUserBackToFront,
    formatTextFromToBack,
    resetAllTag,
  ] as const;
  // !! Commentaire à ne pas supprimer => c'est la maniere dont les tags sont géré
  // ? @[{"userId":6303472e02dbcd00245423c0, name:Clémence, position:0, endPosition:6}]
};

export default useTagUser;
